import { render, staticRenderFns } from "./TariffShop.vue?vue&type=template&id=6d740320"
import script from "./TariffShop.vue?vue&type=script&lang=js"
export * from "./TariffShop.vue?vue&type=script&lang=js"
import style0 from "./TariffShop.vue?vue&type=style&index=0&id=6d740320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports